import * as React from "react";
import { Brand } from "../components/services/section-action";
import EasyOnboarding from "../images/easy-onboarding.png";
import Results from "../images/facebook-ads/results.png";
import Success from "../images/facebook-ads/success.png";
import FacebookAds from "../images/facebook-ads/facebook-ads.png";
import Instagram from "../images/facebook-ads/instagram.png";
import { FaqProps } from "../components/faq";
import { GetItAllProps } from "../components/services/get-it-all";
import GetItAllBgLeft from "../images/facebook-ads/get-it-all-bg-left.png";
import GetItAllBgRight from "../images/facebook-ads/get-it-all-bg-right.png";
import { TrustedbyEntity } from "../components/trusted-by";
import { FeatureProps } from "../components/feature";
import {
  baseRatedFeatures,
  metaTrustedByEntity,
  googleTrustedByEntity,
  secretRecipeFeature,
  tiktokTrustedByEntity,
  americanFulfillmentEntity,
  microsoftTrustedByEntity,
  bestWorkPlacesTrustedByEntity,
  forbesTrustedByEntity,
  EntrepreneurTrustedByEntity,
  fiveThousandIncTrustedByEntity,
  incPowerTrustedByEntity,
  IncRegionalsTrustedByEntity,
} from ".";
import FacebookAdsSecretRecipies from "../images/facebook-ads/facebook-ads-secret-recipies.png";

export const trustedByEntities: TrustedbyEntity[] = [
  fiveThousandIncTrustedByEntity,
  bestWorkPlacesTrustedByEntity,
  americanFulfillmentEntity,
  incPowerTrustedByEntity,
  IncRegionalsTrustedByEntity,
  forbesTrustedByEntity,
  EntrepreneurTrustedByEntity,
  metaTrustedByEntity,
  tiktokTrustedByEntity,
  googleTrustedByEntity,
];

export const easyAsFeatures = [
  {
    title: "Quick & Easy Onboarding",
    text: "Provide clients’ details in our easy-to-use form and our 100% USA-based team will be off to the races.",
    image: EasyOnboarding,
  },
  {
    title: "We'll Get the Results",
    text: "Sit back and relax while our experts perform proven optimizations to get your clients the best results.",
    image: Results,
  },
  {
    title: "Reporting to Prove Success",
    text: "Look like a hero showing off your clients' results with our white labeled reporting dashboards.",
    image: Success,
  },
];

export const brands: Brand[] = [
  {
    src: FacebookAds,
    alt: "Facebook Ads",
    styles: { maxWidth: "220px" },
  },
  {
    src: Instagram,
    alt: "Instagram",
  },
];

export const faqs: FaqProps[] = [
  {
    title: "What is white label Facebook Ads management?",
    text: (
      <>
        <p>
          White label (also known as private label or reseller services), in the
          context of Facebook Ads management, refers to the act of another
          agency (e.g. us, Agency Elevation) providing the fulfillment of your
          agency’s Facebook Ads management services for your clients.
        </p>
        <p>
          This also means your end clients would have no idea we exist, and
          hence the white or private label designation. Everything we do would
          be branded under you and your agency, meaning the work we would do
          would be indistinguishable from as if the work were done by in-house
          employees of yours.
        </p>
        <p>
          White label Facebook Ads management isn’t merely just an equivalent
          alternative to in-house however, as you’ll discover below. There are
          some big advantages to avoiding in-house labor and partnering with a
          private label provider like us.
        </p>
      </>
    ),
  },
  {
    title:
      "Why should my agency use white label Facebook Ads management services?",
    text: (
      <>
        <p>
          Finding, interviewing, hiring, training, paying, and retaining
          in-house Facebook Ads specialists is super time intensive and costly.
          Many will request continual pay raises and eventually may leave you,
          taking their skills elsewhere, putting you back at square one. Not to
          mention the cost of health insurance and other benefits should you
          offer them.
        </p>
        <p>
          Fulfilling in-house means you’ll also have awkward periods where you
          have too much work for one employee, but not enough to maximize or
          even justify your return on hiring a second employee, creating a
          logjam and inefficiencies. With our whitel label service, you pay per
          account, so you never pay more than you need for the work done; it’s
          always just right! Not to mention we can handle endless scale. Quickly
          add 10 clients out of nowhere? No worries, just send them over!
        </p>
        <p>
          Another big issue with in-house that many agencies don’t consider is
          just how involved, time intensive, and costly training and
          accountability is. When you hire an in-house Facebook Ads specialist,
          who ensures they know what to do? Most agencies can’t afford to hire
          super expensive, skilled, and trained Facebook Ads specialists.
          They’re often junior type or mid-level (at best) employees. Guess who
          then gets to train them and hold their hands? You or valuable members
          of your team!
        </p>
        <p>
          Who ensures they get better over time? The training never ends. The
          Facebook Ads platform never stops changing. This is a massive lifetime
          time-value cost on the agency that you absorb for each employee by
          simply needing to make sure you continuously hold them accountable and
          help them improve. White labeling with us? It’s our responsibility!
          And our team is trained by the best as our leadership has credentials
          in the Facebook Ads space that are hard to match.
        </p>
      </>
    ),
  },
  {
    title: "How does your white label Facebook Ads management work?",
    text: (
      <>
        <p>
          Easier than you could imagine! The first step begins with you
          completing our simple onboarding intake form for each of your Facebook
          Ads clients, which provides us the vital information we need to be
          successful for each client. From there, we’re off and running quickly!
          New campaign builds we can often have live in a matter of a day or
          two, and if the campaigns are running already, we’ll jump in right
          away to begin optimizing!
        </p>
        <p>
          Communication runs through email and/or us joining your team’s Slack
          channel, which we’ve found works very well. You’ll view us no
          differently than you would an in-house employee! We too are available
          over Zoom to discuss results and strategy as needed. Our 100%
          USA-based team is available during the same time zones you are in,
          meaning nothing lags and everything is quick and responsive.
        </p>
        <p>
          In terms of work performed, our white label Facebook Ads management
          entails a sophisticated custom recipe for each of your clients. Each
          client’s account will be optimized and reviewed weekly, with
          optimizations including but not limited to creating new ads, ad sets,
          and audiences, in addition to the iteration and testing of each over
          time. This paired with constant analysis and research means better
          results over time, and more revenue for your clients (and in turn,
          you!).
        </p>
        <p>
          At the conclusion of each month, you’ll receive an auto-generated and
          emailed (to you and/or your clients) report with your client’s results
          for the month prior. The report will be branded with your agency’s
          logo and help position the value of the service you’re selling. This
          report is included with our standard white label pricing at no
          additional charge to you.
        </p>
      </>
    ),
  },
  {
    title:
      "Why is Agency Elevation’s white label Facebook Ads management services better than its competitors’?",
    text: (
      <>
        <p>
          Our white label Facebook Ads team is 100% USA-based. We have two
          locations, one in Wisconsin and one in Pennsylvania, in addition to
          team members in other states. What this means for you is that you’ll
          receive top-notch quality care and support, with our team operating in
          the same time zone(s) as you, fluent in English as a first-language
          (helpful for ad copy writing), and that you’ll be supporting
          home-grown, American business in working with us.
        </p>
        <p>
          Our pricing is also the most competitive we’ve seen for what we offer.
          Our Facebook Ads optimizations are performed weekly, our reporting is
          robust, and our communication is clear and as quick as exists. Pricing
          also includes special volume discounts that get cheaper as you add
          more clients, meaning we’re set up to grow and scale with you. No
          hidden fees, setup costs, contracts, or other red tape, just easy,
          transparent pricing with great results!
        </p>
        <p>
          Perhaps most importantly of all, we believe we’re very good at what we
          do. Our leadership who sets the tempo and creates the Facebook Ads
          optimization recipes our team executes has experience managing
          multi-million dollar Facebook Ads budgets for Fortune 50 brands.
          They’ve seen it all and your clients will receive this expertise and
          the results that accompany it.
        </p>
      </>
    ),
  },
  {
    title:
      "When could I begin your white label Facebook Ads management services?",
    text: (
      <p>
        Right away! Just click the ‘get pricing’ button and from there schedule
        your free consultation. We’re ready the second you are!
      </p>
    ),
  },
];

export const getItAllContents: GetItAllProps = {
  text: "What we do is never stale and always innovative and improving, but here's a sampling.",
  lists: [
    [
      "Weekly Ad Account Optimizations",
      "Custom Audience Creation",
      "Retargeting Ads",
      "Daily Slack Communication",
      "Ad Copy Creation",
      "Reporting Dashboards",
      "Campaign Performance Analysis",
      "Landing Page Recommendations",
      "Performance Insights",
      "Proactive Updates",
      "Ads Testing"
    ],
    [
      "Campaign Build-outs",
      "Audience Testing",
      "Offer Recommendations",
      "Budget Recommendations",
      "Image Creative Production",
      "Conversion Tracking Audits",
      "In-app Lead Form Design & Creation",
      "Strategy Discussions",
      "Budget Management",
      "Ad Copy Optimization",
      "Weekly Wins"
    ],
  ],
  bgLeft: GetItAllBgLeft,
  bgRight: GetItAllBgRight,
};

export const ratedFeatures: FeatureProps[] = [
  ...baseRatedFeatures,
  { ...secretRecipeFeature, image: FacebookAdsSecretRecipies },
];
